var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-card"},[_c('div',{staticClass:"card-content"},[_c('span',{staticClass:"paragraph-20-weight300"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"fontSize20 card-value"},[_vm._v(_vm._s(_vm._f("formatNumberZero")(_vm.value)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }